<template>
    <div class="card-filters">
        <div class="row position-relative">
            <div class="col-12 text-center">
                <strong>
                    {{ data_client.name }} ({{ data_client.number }})
                </strong>
            </div>
            <div class="card-filters-right">
                <el-button size="small"
                    @click="showDialogEdit = true"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-5m-1.414-9.414a2 2 0 1 1 2.828 2.828L11.828 15H9v-2.828z"/></svg>
                </el-button>
                <el-button size="small"
                    @click="showDialogGenerate = true"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M7.007 12a.75.75 0 0 1 .75-.75h3.493V7.757a.75.75 0 0 1 1.5 0v3.493h3.493a.75.75 0 1 1 0 1.5H12.75v3.493a.75.75 0 0 1-1.5 0V12.75H7.757a.75.75 0 0 1-.75-.75"/><path fill="currentColor" fill-rule="evenodd" d="M7.317 3.769a42.5 42.5 0 0 1 9.366 0c1.827.204 3.302 1.643 3.516 3.48c.37 3.157.37 6.346 0 9.503c-.215 1.837-1.69 3.275-3.516 3.48a42.5 42.5 0 0 1-9.366 0c-1.827-.205-3.302-1.643-3.516-3.48a41 41 0 0 1 0-9.503c.214-1.837 1.69-3.276 3.516-3.48m9.2 1.49a41 41 0 0 0-9.034 0A2.486 2.486 0 0 0 5.29 7.424a39.4 39.4 0 0 0 0 9.154a2.486 2.486 0 0 0 2.193 2.164c2.977.332 6.057.332 9.034 0a2.486 2.486 0 0 0 2.192-2.164a39.4 39.4 0 0 0 0-9.154a2.486 2.486 0 0 0-2.192-2.163" clip-rule="evenodd"/></svg>
                </el-button>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12 text-center" v-show="data_client.contact_name || data_client.contact_email"
                :class="columnsDinamics(data_client)"
            >
                <span>{{ data_client.contact_name }}</span>
                <template v-show="data_client.contact_email">
                    <br>
                    <strong>{{ data_client.contact_email }}</strong>
                </template>
            </div>
            <div class="col-12 text-center" v-show="data_client.contact_whatsapp"
                :class="columnsDinamics(data_client)"
            >
                <span>WHATSAPP</span>
                <br>
                <strong>{{ data_client.contact_whatsapp }}</strong>
            </div>
            <div class="col-12 text-center" v-show="data_client.created_at"
                :class="columnsDinamics(data_client)"
            >
                <span>CREADO {{ data_client.created_at }}</span>
                <br>
                <strong>{{ data_client.created_at_diff }}</strong>
            </div>
        </div>
        <div class="row mt-2 pb-2 border-buttom-filters">
            <div class="col-12 col-md-3 text-center">
                <span>PAGADO</span><br>
                <strong class="text-success">S/ {{ data_client.total_paid }}</strong>
            </div>
            <div class="col-12 col-md-3 text-center">
                <span>PENDIENTE</span><br>
                <strong class="text-new-warning">S/ {{ data_client.total_pending }}</strong>
            </div>
            <div class="col-12 col-md-3 text-center">
                <span>VENCIDO</span><br>
                <strong class="text-danger">S/ {{ data_client.total_defeated }}</strong>
            </div>
            <div class="col-12 col-md-3 text-center">
                <span>ANULADO</span><br>
                <strong class="text-muted">S/ {{ data_client.total_voided }}</strong>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 col-md-6 col-lg-3 text-center">
                <span>PLAN</span><br>
                <strong>{{ data_client.plan }}</strong>
            </div>
            <div class="col-12 col-md-6 col-lg-3 text-center">
                <span>PRECIO</span><br>
                <strong>{{ data_client.plan_price }}</strong>
            </div>
            <div class="col-12 col-md-6 col-lg-3 text-center">
                <span>PERIODO</span><br>
                <strong>{{ data_client.period }}</strong>
            </div>
            <div class="col-12 col-md-6 col-lg-3 text-center">
                <span>SERVICIO</span><br>
                <strong :class="[ data_client.service ? 'text-danger' : 'text-success' ]">
                    {{ data_client.service ? 'INACTIVO' : 'ACTIVO' }}
                </strong>
            </div>
        </div>

        <Form
            :showDialog.sync="showDialogGenerate"
            :recordId="data_client.id"
            @registered="$emit('reloadData')"
        />

        <FormContact
            :showDialog.sync="showDialogEdit"
            :recordId="data_client.id"
            @updated="$emit('reloadInfoClient')"
        />
    </div>
</template>

<script>
    import Form from './form.vue'
    import FormContact from './form-contact.vue'

    export default {
        components: { Form, FormContact },
        props: {
            data_client: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                showDialogEdit: false,
                showDialogGenerate: false
            }
        },

        methods: {
            columnsDinamics(row) {
                if (row.contact_name || row.contact_email) {
                    if (row.contact_whatsapp && row.created_at) {
                        return 'col-md-4'
                    } else if (row.contact_whatsapp || row.created_at) {
                        return 'col-md-6'
                    }
                }
                return 'col-md-12'
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/payments/components/card-client.vue